/** Owner-provided job descriptions; unresolved placeholders remain explicit. */
export const careerPositions = [
  {
    id: "engineer",
    title: "Agent 技术负责人 / LLM 应用工程师",
    category: "技术研发",
    location: "上海",
    details: ["到岗时间：越快越好（关键节点：11 月 MVP 演示）"],
    summary: "LLM 应用工程师（Agent 方向）",
    introduction: [
      "Mirafans 真人形象资产授权交易平台。当 AI 短剧/漫剧/数字人营销爆发式增长（2026 上半年抖音新上线 AI 剧超 22 万部），每个内容生产方都面临同一个问题：用谁的脸，谁来授权，怎么合规。我们持有答案——授权本身。",
      "你负责把这个答案产品化：做一个「授权 Agent」，让客户从提需求到拿到授权方案，全程自动化。",
    ],
    responsibilities: [
      "根据产品经理和技术的要求交付授权 Agent MVP（最高优先级，服务 11 月融资演示）：需求解析 → 匹配已签形象 → 生成授权方案与报价 → 输出合同初稿。半规则引擎 + 大模型 API 调用即算完整闭环，不求技术炫技，求「演示时投资人看得懂、客户用得上」。",
      "与运营/经纪协作，把 600+ 合同的结构化数据（授权范围、期限、分成条款）清洗成 Agent 可检索的知识库。",
      "接入主流视频生成模型的 API（如豆包/Seedance、可灵、Vidu 等），验证「授权形象 → 客户生成内容」的调用链路。",
      "设计授权履约的技术凭证：调用记录、内容标识（配合 AI 内容逐集标识的合规要求）、分账数据口径。",
    ],
    requirements: [
      "2 年以上工程经验，有 LLM 应用落地经验（RAG / Agent / 工作流编排任一均可，有完整交付过产品的加分）。",
      "熟练使用至少一家大模型 API，理解 prompt 工程与结构化输出，能判断「该用规则还是该用模型」。",
      "Python 或 Node.js 任一全栈能力，能扛住 MVP 全周期。",
      "能接受早期创业节奏：快交付、勤演示、边跑边改。",
    ],
    bonuses: [
      "内容/版权/AI 生成方向的产品经验。",
      "熟悉《生成式 AI 服务管理暂行办法》《微短剧发展管理办法》相关条款。",
      "自己做过数字人/短剧/漫剧相关 side project。",
    ],
  },
  {
    id: "business",
    title: "商业化策略经理 / BD 经理",
    category: "商务合作",
    location: "上海",
    details: ["Base 地灵活，接受较多出差（上海/杭州为主）"],
    summary: "商业化策略（BD 方向）",
    introduction: [],
    responsibilities: [
      "绘制客户地图并分层触达：AI 短剧出品方、承制方、营销侧，判断决策链与预算口径，输出优先级排序。",
      "设计报价与分账结构：按部计费 / 分账 / 买断三档结构化报价，针对客户体量（上市公司/平台/小承制方）给出差异化方案。",
      "主导商务谈判全流程：从 cold touch 到合同条款，重点守住结算模式红线——预付小额或平台托管分账，不做先交付后收款的乙方。",
      "支持 11 月最小闭环：配合内容线完成「一部剧、一个账号、一笔到账」，把闭环过程整理成可复制的销售案例与 BP 素材。",
      "市场情报回流：客户对形象类型、授权方式的真实需求，反向指导签约团队「签什么样的达人」。",
    ],
    requirements: [
      "3 年以上文娱/内容/IP/广告方向的商务或商业化经验，有影视、短剧、MCN、版权或 4A/AI 营销任一领域 deal-closed 记录。",
      "熟悉平台分账/版权授权类合同的基本结构，看得懂结算条款里的坑。",
      "能独立面对上市公司级别客户，也能跟小承制方老板蹲在横店聊。",
      "结果导向：你的 KPI 是签约意向数与到账金额，不是触达数量。",
    ],
    bonuses: [
      "有短剧/AI 内容公司客户资源，能直接约到决策人。",
      "理解 AI 内容合规新规（逐集标识、肖像权审查）如何变成客户的采购动因。",
      "有过「把无形资产/授权类产品卖出第一单」的经验。",
    ],
  },
  {
    id: "operations",
    title: "达人运营 / 签约运营",
    category: "用户与内容运营",
    location: "上海",
    details: ["汇报对象：【创始人 / 经纪线负责人】"],
    summary: "达人签约与授权运营",
    introduction: [],
    responsibilities: [
      "签约扩张：按商业化需求反推的达人画像（粉丝体量区间、内容垂类、授权意愿度），批量触达与签约，维护签约转化漏斗数据。",
      "已签达人服务与履约：授权调用发生时同步达人、结算分账数据、处理授权范围异议——让 600 个签约者愿意续约、愿意介绍同行。",
      "合同与数据运营：与 Agent 技术线协作，把新签合同的关键条款结构化录入，保证授权 Agent 能检索、能报价。",
      "达人信任维护：定期回访、分账透明化（账单可查）、敏感场景（形象被用于何种内容）及时沟通，把「平台信任」沉淀成续约率数据。",
      "输出签约 SOP 与达人 FAQ 话术库，为团队扩张后的规模化签约做准备。",
    ],
    requirements: [
      "2 年以上达人/主播/艺人经纪、MCN 签约或主播运营经验，有批量签约的实际案例。",
      "熟悉达人侧的真实顾虑（形象安全、分账透明、竞业与授权范围），会讲「授权而不是卖脸」。",
      "数据意识：能维护签约漏斗、续约率、分账准时率等核心指标，而不是凭感觉运营。",
      "情绪耐受力：达人关系是长跑，你面对的是几百个独立的信任关系。",
    ],
    bonuses: [
      "自带达人资源或垂类渠道（颜值/剧情/生活方式类优先）。",
      "经历过 MCN 纠纷或授权争议处理，懂得合同条款如何前置规避。",
      "用过 AI 分身/数字人工具，理解达人对其形象 AI 化的接受度差异。",
    ],
  },
] as const;
